import screenWidth from '../utils/constant';

export default class PDFJs {
	init = (source, element) => {
		const iframe = document.createElement('iframe');

		iframe.src = `/pdfjs-2.3.200-dist/web/viewer.html?file=${source}`;
		iframe.width = '100%';
		iframe.height = window.innerWidth > screenWidth.Mobile ? '500px' : '250px';

		element.appendChild(iframe);
	};
}



// WEBPACK FOOTER //
// ./backend/pdfjs.js